/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Components */
import LiveStartTime from '../LiveStartTime';
import LiveTimeLeft from '../LiveTimeLeft';
import LiveInteractiveTag from '../LiveInteractiveTag';

/*  Utils */
import { isInteractivityAllowed } from '../../utils/metaDataUtils';
import { useUserAccount } from '../../providers/UserProvider';

/*  Storages */
import { Schedule } from '../../storage/models';

/* Styles */
import './LiveDetail.scss';

function LiveDetail({
  schedule,
  startDate,
  endDate,
  isPlayingNow,
}) {
  const { uid: userId, iso2Code } = useUserAccount() || {};
  const isInteractive = isInteractivityAllowed(schedule, iso2Code, userId);

  return (
    <div className="dtv-html5-c-featured-carousel-card__content-live-interactive-tag">
      {isPlayingNow ? (
        <LiveTimeLeft
          startDate={startDate}
          endDate={endDate}
          className="dtv-html5-c-detail-live__detail-container__live-end"
        />
      ) : (
        <LiveStartTime
          startDate={startDate}
          endDate={endDate}
          className="dtv-html5-c-detail-live__detail-container__live-start"
        />
      )}
      {isInteractive && (
        <div className="dtv-html5-c-detail-live__interactivity-tag-container">
          <LiveInteractiveTag />
        </div>
      )}
    </div>
  );
}

LiveDetail.defaultProps = {
  schedule: undefined,
  startDate: undefined,
  endDate: '',
  isPlayingNow: false,
};

LiveDetail.propTypes = {
  schedule: PropTypes.instanceOf(Schedule),
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  isPlayingNow: PropTypes.bool,
};

export default memo(LiveDetail);
